import { useMemo } from "react";
import { IFavoritePropertyDetails } from "../interfaces/IFavorite";
import Shape from "../interfaces/Shape";
import GeometryService from "../services/geometryService";

export default function (properties: IFavoritePropertyDetails[], shape: Shape | Shape[] | null): IFavoritePropertyDetails[] {
    const geometryService = useMemo(() => new GeometryService(), []);

    return useMemo(() => shape ? properties.filter(p => geometryService.isPointInsideShape(p.centerPoint, shape)) : properties, [properties, shape]);
}